import { render, staticRenderFns } from "./chat-box.vue?vue&type=template&id=2b2be760&scoped=true"
import script from "./chat-box.vue?vue&type=script&lang=js"
export * from "./chat-box.vue?vue&type=script&lang=js"
import style0 from "./chat-box.vue?vue&type=style&index=0&id=2b2be760&prod&lang=css"
import style1 from "./chat-box.vue?vue&type=style&index=1&id=2b2be760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../mnt/host/d/wwwroot/deepcityAI/user-client-pc/user-client-common-pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2be760",
  null
  
)

export default component.exports